import React from "react";
import { stats } from "../mock";

const About = () => {
  return (
    <section id="about" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div>
            <span className="inline-block bg-[#fef3c7] text-[#92590a] text-xs tracking-[0.28em] uppercase font-medium px-4 py-2 rounded-full">
              Est. 2023
            </span>
            <h2 className="font-serif-display text-[#0e0e0f] mt-8 leading-[1.05]" style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
              Mai mult decât structuri.<br />Construim culturi.
            </h2>
            <p className="mt-8 text-neutral-600 text-base md:text-[17px] leading-relaxed max-w-lg">
              STG este un studio de arhitectură care crede că un design excelent începe cu echipe puternice. Creăm spații unde colaborarea înflorește, inovația apare și oamenilor le place să vină la muncă.
            </p>
          </div>

          <div className="flex flex-col gap-10 md:pt-4">
            {stats.map((s) => (
              <div key={s.label} className="flex items-start gap-8">
                <div className="font-serif-display text-[#f5b301] leading-none" style={{ fontSize: "clamp(3rem, 5vw, 5rem)" }}>
                  {s.value}
                  <span className="text-[0.7em]">{s.suffix}</span>
                </div>
                <div className="pt-2">
                  <div className="text-[#0e0e0f] font-semibold text-lg">{s.label}</div>
                  <div className="text-neutral-500 mt-1 text-sm">{s.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
